'use client'

import { useState, useEffect } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/Button'
import { useAuthStore, useAuthModalStore } from '@/stores'

interface LoginButtonProps {
  className?: string
}

export default function LoginButton({ className }: LoginButtonProps) {
  const t = useTranslations('common')
  const router = useRouter()
  const { isAuthenticated } = useAuthStore()
  const { openLoginModal } = useAuthModalStore()
  const pathname = usePathname()
  const [isLoading, setIsLoading] = useState(false)

  // Reset loading state when pathname changes (navigation completed)
  // This synchronous setState is intentional - we want to reset on route change
  /* eslint-disable react-hooks/set-state-in-effect */
  useEffect(() => {
    setIsLoading(false)
  }, [pathname])
  /* eslint-enable react-hooks/set-state-in-effect */

  // Don't show anything when authenticated
  if (isAuthenticated) {
    return null
  }

  // Check if we're on the builder page
  const isBuilderPage = pathname === '/builder'

  // Handle click
  const handleClick = () => {
    if (isBuilderPage) {
      // Open the modal via store
      openLoginModal()
    } else {
      // Navigate to login with loading state
      setIsLoading(true)
      router.push('/login')
    }
  }

  return (
    <Button onClick={handleClick} loading={isLoading} className={className}>
      {t('login')}
    </Button>
  )
}
